import client from '../ApolloClient'
import gql from 'graphql-tag'
import {
  FETCH_GLOBAL_CONFIG, loadGlobalConfig, failFetch
} from '../Actions/Global'
// eslint-disable-next-line
import { Observable, Subject, filter, switchMap, map } from 'rxjs'

const globalConfigQuery = gql`query {
  getGlobalConfig {
    _id
    enableFeatureSmsAlerts
  }
}`

/**
 * globalConfigEpic
 * @desc action Observer that sends a query and processes result if the action is a fetch global config action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const globalConfigEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_GLOBAL_CONFIG),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: globalConfigQuery })
        .then((data) => {
          subject.next(data)
        })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadGlobalConfig(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
